export const ACL_MODULE_MAPPING = {
  COMMON: 0,
  ACCOUNT: 1,
  XOXO_POINT: 2,
  XOXO_VOUCHER: 3,
  PLUM_PRO: 6,
  CAMPAIGN: 4,
  RECHARGE: 5,
  REPORTS: 7,
  EMPULS: 8,
  MAGIC_VOUCHER: 9,
  PERKS: 10,
  WALLET: 11,
  XOXO_LINK: 12,
  SAP_INTEGRATION: 13,
  DARWINBOX_INTEGRATION: 14,
  STOREFRONT_INTEGRATION: 15,
  PLUM_PRO_API: 100,
};

export const MODULE_ACL_SWITCH = true;
export const AWARD_CHECK_STATUS = 1;
